(function() {
  'use strict';
  // Customer-facing copy comes from window.theme.strings (emitted by
  // snippets/head.liquid from the locale files) so it follows the storefront
  // language. The English argument stays as the fallback for any context where
  // theme.strings has not loaded.
  function themeStr(key, fallback) {
    var s = window.theme && window.theme.strings;
    return (s && s[key]) || fallback;
  }

  // Display-only lookups. The VALUE submitted for country/state stays the
  // English string the backend and Stripe expect; only the visible label is
  // swapped. An unknown key falls through to the English it was given.
  function fieldLabel(en) {
    var m = window.theme && window.theme.strings && window.theme.strings.formLabels;
    return (m && m[en]) || en;
  }
  function placeLabel(en) {
    var m = window.theme && window.theme.strings && window.theme.strings.places;
    return (m && m[en]) || en;
  }


  // Webhook Configuration
  // Stripe checkout webhooks
  const STRIPE_INITIATE_CHECKOUT_WEBHOOK_URL = 'https://n8n-latest-1-js6i.onrender.com/webhook/stripe-checkout/initiate';
  const STRIPE_FORM_SUBMIT_WEBHOOK_URL = 'https://n8n-latest-1-js6i.onrender.com/webhook/stripe-checkout/form-submit';
  const WEBHOOK_TOKEN = 'IB98yh97b08G97Vvyf9797V7Vex5s34';
  
  // Function to get webhook URL
  function getWebhookURL(type) {
      return type === 'initiate' ? STRIPE_INITIATE_CHECKOUT_WEBHOOK_URL : STRIPE_FORM_SUBMIT_WEBHOOK_URL;
  }
  
  // Discount codes
  const DISCOUNT_CODES = {
    'DUA5': { rate: 0.05, name: '5% Off' },
    'DUAAA99': { rate: 0.99, name: '99% Off' },
    'SECRETSANTA25': { rate: 0.20, name: '20% Off' }
  };

  // State
  let cartData = null;
  let appliedDiscount = null;

  // ============================================
  // REUSED FUNCTIONS FROM tally-checkout.js
  // ============================================

  // Function to fetch cart data
  async function getCartData() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) {
        throw new Error('Failed to fetch cart data');
      }
      return await response.json();
    } catch (error) {
      return null;
    }
  }

  // Function to format product GID
  function formatProductGID(productId) {
    return `gid://shopify/Product/${productId}`;
  }

  // Function to convert price to market currency - use helper if available
  function convertToMarketCurrency(priceInCents) {
    if (window.WebhookHelper && typeof window.WebhookHelper.convertToMarketCurrency === 'function') {
      return window.WebhookHelper.convertToMarketCurrency(priceInCents);
    }
    // Fallback to MarketConfig
    if (window.MarketConfig && typeof window.MarketConfig.convertPrice === 'function') {
      return window.MarketConfig.convertPrice(priceInCents);
    }
    // Fallback to old systems for backward compatibility
    if (window.MetaPixelEnAe && typeof window.MetaPixelEnAe.convertToAED === 'function') {
      return window.MetaPixelEnAe.convertToAED(priceInCents, true);
    }
    // Last resort fallback
    const rate = (window.AED_CONFIG && window.AED_CONFIG.rate) || 0.04;
    const inrAmount = priceInCents / 100;
    const convertedAmount = inrAmount * rate;
    return parseFloat(convertedAmount.toFixed(2));
  }
  
  // Keep convertToAED for backward compatibility (now uses MarketConfig)
  function convertToAED(priceInCents) {
    return convertToMarketCurrency(priceInCents);
  }

  // Function to get Meta Pixel identifiers - use helper if available
  function getMetaPixelIdentifiers() {
    if (window.WebhookHelper) {
      return {
        fbp: window.WebhookHelper.getFbpCookie(),
        fbc: window.WebhookHelper.getFbcCookie()
      };
    }
    
    // Fallback: manual cookie extraction
    const identifiers = { fbp: null, fbc: null };
    try {
      const fbpMatch = document.cookie.match(/(?:^|; )_fbp=([^;]+)/);
      if (fbpMatch) identifiers.fbp = fbpMatch[1];

      const fbcMatch = document.cookie.match(/(?:^|; )_fbc=([^;]+)/);
      if (fbcMatch) {
        const fbc = fbcMatch[1];
        if (!fbc.endsWith('.fbclid') && fbc.split('.').length >= 4) {
          identifiers.fbc = fbc;
      }
    }
    } catch (e) {
      // Silently ignore
    }
    return identifiers;
  }

  // Generate event ID - use helper if available
  function generateEventId() {
    if (window.WebhookHelper && typeof window.WebhookHelper.generateEventId === 'function') {
      return window.WebhookHelper.generateEventId();
    }
    // Fallback: manual generation
    function generateHex(length) {
      return Array.from({length: length}, () => 
        Math.floor(Math.random() * 16).toString(16).toUpperCase()
      ).join('');
    }
    return 'sh-' + generateHex(8) + '-' + generateHex(4) + '-' + 
           generateHex(4) + '-' + generateHex(4) + '-' + generateHex(12);
  }

  // Function to build webhook payload for form submission (includes all customer data)
  function buildWebhookPayload(cart, formData, localeInfo) {
    const eventId = generateEventId();
    const eventTime = Math.floor(Date.now() / 1000);
    
    // Get current market info for catalog prefixing and gateway
    let marketInfo = null;
    let catalogPrefix = '';
    let gateway = 'razorpay';
    
    if (window.MarketConfig && typeof window.MarketConfig.getCurrentMarket === 'function') {
      marketInfo = window.MarketConfig.getCurrentMarket();
      if (marketInfo && marketInfo.config) {
        catalogPrefix = marketInfo.config.catalogPrefix || '';
        gateway = marketInfo.config.gateway || 'razorpay';
      }
    }
    
    // Build content_ids - use helper if available, otherwise MarketConfig
    const variantIds = cart.items.map(item => item.variant_id.toString());
    let contentIds = variantIds;
    if (window.WebhookHelper && typeof window.WebhookHelper.prefixContentIds === 'function') {
      contentIds = window.WebhookHelper.prefixContentIds(variantIds);
    } else if (window.MarketConfig && typeof window.MarketConfig.prefixContentIds === 'function') {
      contentIds = window.MarketConfig.prefixContentIds(variantIds);
    }
    
    // Build contents array with proper currency conversion for all markets
    const contents = cart.items.map((item, index) => {
      const variantId = item.variant_id.toString();
      const prefixedVariantId = contentIds[index] || variantId;
      
      // Use convertToMarketCurrency for all markets (not just AED)
      const unitPrice = convertToMarketCurrency(item.final_price);
      
      return {
        id: prefixedVariantId,
        sku: prefixedVariantId,
        item_price: unitPrice,
        quantity: item.quantity,
        currency: localeInfo.currency
      };
    });
    
    // Get Meta Pixel identifiers
    const metaPixelIds = getMetaPixelIdentifiers();
    
    // Calculate subtotal using convertToMarketCurrency for all markets
    let subtotal = convertToMarketCurrency(cart.total_price);
    
    // Apply discount if available
    if (appliedDiscount) {
      subtotal = subtotal - appliedDiscount.discountAmount;
    }
    
    // Build product data for hidden fields (up to 10 items)
    const productData = {};
    const maxItems = Math.min(cart.items.length, 10);
    for (let i = 0; i < maxItems; i++) {
      const item = cart.items[i];
      const index = i + 1;
      productData[`product_gid_${index}`] = formatProductGID(item.product_id);
      productData[`variant_id_${index}`] = item.variant_id.toString();
      productData[`quantity_${index}`] = item.quantity.toString();
      // Use market currency for price (convertToMarketCurrency handles all markets)
      const itemPrice = convertToMarketCurrency(item.line_price);
      productData[`price_${localeInfo.currency.toLowerCase()}_${index}`] = itemPrice.toFixed(2);
      // Keep price_aed for backward compatibility (but use converted price)
      productData[`price_aed_${index}`] = itemPrice.toFixed(2);
    }
    
    // Get default country from form config if available
    let defaultCountry = 'United Arab Emirates';
    if (window.MarketFormConfig && marketInfo && marketInfo.config) {
      const formConfig = window.MarketFormConfig.getFormConfig(marketInfo.config.market);
      if (formConfig && formConfig.countryName) {
        defaultCountry = formConfig.countryName;
      }
    }
    
    // Build payload with all customer data
    const payload = {
      event_name: 'InitiateCheckout',
      event_time: eventTime,
      event_id: eventId,
      event_source_url: window.location.href,
      action_source: 'website',
      
      // Meta Pixel Identifiers
      fbp: metaPixelIds.fbp,
      fbc: metaPixelIds.fbc,
      
      // Contact Information
      email: formData.email,
      phone: formData.phone,
      
      // Shipping Address
      shipping_address: {
        first_name: formData.firstName,
        last_name: formData.lastName,
        address1: formData.address,
        address2: formData.apartment || '',
        city: formData.city,
        province: formData.state,
        zip: formData.postalCode,
        country: formData.country || defaultCountry
      },
      
      // User Data
      user_data: {
        client_user_agent: navigator.userAgent,
        client_ip_address: null,
        em: formData.email ? [formData.email.toLowerCase()] : null,
        ph: formData.phone ? [formData.phone.replace(/\D/g, '')] : null
      },
      
      // Custom Data
      custom_data: {
        value: subtotal,
        currency: localeInfo.currency,
        content_type: 'product_group',
        content_ids: contentIds,
        num_items: cart.items.length,
        market: localeInfo.market,
        checkout_type: 'custom',
        contents: contents,
        gateway: gateway,
        catalog_prefix: catalogPrefix
      },
      
      // Discount Information
      discount: appliedDiscount ? {
        code: appliedDiscount.discountCode,
        amount: appliedDiscount.discountAmount,
        rate: DISCOUNT_CODES[appliedDiscount.discountCode]?.rate || null
      } : null,
      
      // Cart Data
      cart_data: {
        total_price: cart.total_price,
        total_price_converted: subtotal,
        item_count: cart.items.length,
        total_items: cart.items.length.toString(),
        items: cart.items.map((item, index) => ({
          product_id: item.product_id,
          variant_id: item.variant_id,
          quantity: item.quantity,
          final_price: item.final_price,
          final_price_converted: convertToMarketCurrency(item.final_price),
          line_price: item.line_price,
          line_price_converted: convertToMarketCurrency(item.line_price),
          title: item.title || item.product_title || '',
          variant_title: item.variant_title || ''
        }))
      },
      
      // Product Data (for compatibility with Tally form format)
      ...productData,
      subtotal_converted: subtotal.toFixed(2),
      total_items: cart.items.length.toString()
    };
    
    return payload;
  }

  // Function to send webhook
  async function sendWebhook(payload, webhookUrl, attempt = 1) {
    const maxAttempts = 3;
    
    try {
      console.log(`[Custom Checkout] Webhook attempt ${attempt}/${maxAttempts} to ${webhookUrl}`);
      
      const response = await fetch(webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Webhook-Token': WEBHOOK_TOKEN
        },
        body: JSON.stringify(payload),
        keepalive: true,
        mode: 'cors'
      });
      
      console.log(`[Custom Checkout] Webhook response status: ${response.status} ${response.statusText}`);
      
      if (response.ok) {
        const responseText = await response.text();
        console.log('[Custom Checkout] ✅ Webhook sent successfully:', responseText);
        return true;
      } else {
        const responseText = await response.text();
        console.error(`[Custom Checkout] Webhook failed: HTTP ${response.status}: ${response.statusText}`, responseText);
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
    } catch (error) {
      console.error(`[Custom Checkout] Webhook error (attempt ${attempt}):`, error);
      // Retry with exponential backoff
      if (attempt < maxAttempts) {
        const delay = attempt === 1 ? 500 : 2000;
        console.log(`[Custom Checkout] Retrying webhook in ${delay}ms...`);
        await new Promise(resolve => setTimeout(resolve, delay));
        return sendWebhook(payload, webhookUrl, attempt + 1);
      } else {
        console.error('[Custom Checkout] Webhook failed after all retries');
        return false;
      }
    }
  }

  // Function to build initiate checkout webhook payload (without form data)
  function buildInitiateCheckoutPayload(cart, localeInfo) {
    // Get current market info for catalog prefixing and gateway
    let marketInfo = null;
    let catalogPrefix = '';
    let gateway = 'razorpay';
    
    if (window.MarketConfig && typeof window.MarketConfig.getCurrentMarket === 'function') {
      marketInfo = window.MarketConfig.getCurrentMarket();
      if (marketInfo && marketInfo.config) {
        catalogPrefix = marketInfo.config.catalogPrefix || '';
        gateway = marketInfo.config.gateway || 'razorpay';
      }
    }
    
    // Build content_ids - use helper if available, otherwise MarketConfig
    const variantIds = cart.items.map(item => item.variant_id.toString());
    let contentIds = variantIds;
    if (window.WebhookHelper && typeof window.WebhookHelper.prefixContentIds === 'function') {
      contentIds = window.WebhookHelper.prefixContentIds(variantIds);
    } else if (window.MarketConfig && typeof window.MarketConfig.prefixContentIds === 'function') {
      contentIds = window.MarketConfig.prefixContentIds(variantIds);
    }
    
    // Build contents array with proper currency conversion for all markets
    const contents = cart.items.map((item, index) => {
      const variantId = item.variant_id.toString();
      const prefixedVariantId = contentIds[index] || variantId;
      
      // Use convertToMarketCurrency for all markets (not just AED)
      const unitPrice = convertToMarketCurrency(item.final_price);
      
      return {
        id: prefixedVariantId,
        sku: prefixedVariantId,
        item_price: unitPrice,
        quantity: item.quantity,
        currency: localeInfo.currency
      };
    });
    
    // Calculate subtotal using convertToMarketCurrency for all markets
    const subtotal = convertToMarketCurrency(cart.total_price);
    
    // Build hidden fields for compatibility
    const hiddenFields = {};
    const maxItems = Math.min(cart.items.length, 10);
    
    for (let i = 0; i < maxItems; i++) {
      const item = cart.items[i];
      const index = i + 1;
      hiddenFields[`product_gid_${index}`] = formatProductGID(item.product_id);
      hiddenFields[`variant_id_${index}`] = item.variant_id.toString();
      hiddenFields[`quantity_${index}`] = item.quantity.toString();
      // Use market currency for price (convertToMarketCurrency handles all markets)
      const itemPrice = convertToMarketCurrency(item.line_price);
      hiddenFields[`price_${localeInfo.currency.toLowerCase()}_${index}`] = itemPrice.toFixed(2);
      // Keep price_aed for backward compatibility (but use converted price)
      hiddenFields[`price_aed_${index}`] = itemPrice.toFixed(2);
    }
    
    hiddenFields['subtotal_converted'] = subtotal.toFixed(2);
    hiddenFields['total_items'] = cart.items.length.toString();
    
    // Build payload (helper will add event_name, event_time, event_id, fbp, fbc, user_data)
    const payload = {
      // Custom Data
      custom_data: {
        value: subtotal,
        currency: localeInfo.currency,
        content_type: 'product_group',
        content_ids: contentIds,
        num_items: cart.items.length,
        market: localeInfo.market,
        checkout_type: gateway === 'stripe' ? 'standard' : 'tally',
        contents: contents,
        gateway: gateway,
        catalog_prefix: catalogPrefix,
        locale: localeInfo.locale || localeInfo.market.toLowerCase()
      },
      
      // Cart Data
      cart_data: {
        total_price: cart.total_price,
        total_price_converted: subtotal,
        item_count: cart.items.length,
        items: cart.items.map((item, index) => ({
          product_id: item.product_id,
          variant_id: item.variant_id,
          quantity: item.quantity,
          final_price: item.final_price,
          final_price_converted: convertToMarketCurrency(item.final_price),
          title: item.title || item.product_title || ''
        }))
      }
    };
    
    return payload;
  }

  // Function to send initiate checkout webhook (built from cart data on page load)
  async function sendInitiateCheckoutWebhook(cart) {
    try {
      if (!cart || !cart.items || cart.items.length === 0) {
        console.log('[Custom Checkout] No cart data available for initiate checkout webhook');
        return;
      }

      // Detect locale/market using MarketConfig
      let localeInfo = { currency: 'INR', market: 'INR' };
      
      if (window.MarketConfig && typeof window.MarketConfig.getCurrentMarket === 'function') {
        const marketInfo = window.MarketConfig.getCurrentMarket();
        if (marketInfo && marketInfo.config) {
          localeInfo = {
            currency: marketInfo.config.currency,
            market: marketInfo.config.market
          };
        }
      } else {
        // Fallback to old detection method
      const path = window.location.pathname || '';
      const hostname = window.location.hostname || '';
      const href = window.location.href || '';
      const isArAe = path.includes('/ar-ae/') || hostname.includes('ar-ae') || href.includes('/ar-ae/');
      const isEnAe = (window.shopifyLocale && window.shopifyLocale.isEnAe) || path.includes('/en-ae/') || hostname.includes('en-ae') || href.includes('/en-ae/');
      const isArSa = path.includes('/ar-sa/') || hostname.includes('ar-sa') || href.includes('/ar-sa/');
      const isEnSa = path.includes('/en-sa/') || hostname.includes('en-sa') || href.includes('/en-sa/');
      if (isArAe || isEnAe) {
        localeInfo = { currency: 'AED', market: 'UAE' };
      } else if (isArSa || isEnSa) {
        localeInfo = { currency: 'SAR', market: 'Saudi Arabia' };
      } else {
        localeInfo = { currency: 'INR', market: 'INR' };
      }
      }

      // Build webhook payload from cart data and cookies
      const payload = buildInitiateCheckoutPayload(cart, localeInfo);
      
      console.log('[Custom Checkout] Sending initiate checkout webhook...');
      console.log('[Custom Checkout] Webhook payload:', payload);
      
      // Use helper if available (for international markets), otherwise use manual sendWebhook
      if (window.WebhookHelper && window.WebhookHelper.isInternationalMarket && window.WebhookHelper.isInternationalMarket()) {
        // Use helper's sendWebhook for international markets
        window.WebhookHelper.sendWebhook('InitiateCheckout', payload)
          .then(() => {
        console.log('[Custom Checkout] ✅ Initiate checkout webhook sent successfully');
          })
          .catch(error => {
            console.warn('[Custom Checkout] ⚠️ Initiate checkout webhook failed:', error);
          });
      } else {
        // Skip sending InitiateCheckout for non-international markets (India)
        console.log('[Custom Checkout] Skipping InitiateCheckout webhook for non-international market');
      }
    } catch (error) {
      console.error('[Custom Checkout] Error sending initiate checkout webhook:', error);
    }
  }

  // ============================================
  // FORM HANDLING & VALIDATION
  // ============================================

  // Validate email format
  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  // Phone number format configurations by country code
  const PHONE_FORMATS = {
    '+971': { length: 9, name: 'UAE', prefixes: ['4', '5', '6', '7'], errorPrefix: 'UAE numbers' },
    '+1': { length: 10, name: 'US/Canada', prefixes: null, errorPrefix: 'US/Canada numbers' },
    '+44': { length: 10, name: 'UK', prefixes: null, errorPrefix: 'UK numbers' },
    '+91': { length: 10, name: 'India', prefixes: ['6', '7', '8', '9'], errorPrefix: 'Indian numbers' },
    '+86': { length: 11, name: 'China', prefixes: null, errorPrefix: 'Chinese numbers' },
    '+81': { length: 10, name: 'Japan', prefixes: null, errorPrefix: 'Japanese numbers' },
    '+82': { length: 10, name: 'South Korea', prefixes: null, errorPrefix: 'South Korean numbers' },
    '+65': { length: 8, name: 'Singapore', prefixes: null, errorPrefix: 'Singapore numbers' },
    '+60': { length: 9, name: 'Malaysia', prefixes: null, errorPrefix: 'Malaysian numbers' },
    '+66': { length: 9, name: 'Thailand', prefixes: null, errorPrefix: 'Thai numbers' },
    '+61': { length: 9, name: 'Australia', prefixes: null, errorPrefix: 'Australian numbers' },
    '+64': { length: 9, name: 'New Zealand', prefixes: null, errorPrefix: 'New Zealand numbers' },
    '+27': { length: 9, name: 'South Africa', prefixes: null, errorPrefix: 'South African numbers' },
    '+20': { length: 10, name: 'Egypt', prefixes: null, errorPrefix: 'Egyptian numbers' },
    '+966': { length: 9, name: 'Saudi Arabia', prefixes: null, errorPrefix: 'Saudi numbers' },
    '+974': { length: 8, name: 'Qatar', prefixes: null, errorPrefix: 'Qatari numbers' },
    '+965': { length: 8, name: 'Kuwait', prefixes: null, errorPrefix: 'Kuwaiti numbers' },
    '+973': { length: 8, name: 'Bahrain', prefixes: null, errorPrefix: 'Bahraini numbers' },
    '+968': { length: 8, name: 'Oman', prefixes: null, errorPrefix: 'Omani numbers' },
    '+33': { length: 9, name: 'France', prefixes: null, errorPrefix: 'French numbers' },
    '+49': { length: 10, name: 'Germany', prefixes: null, errorPrefix: 'German numbers' },
    '+39': { length: 10, name: 'Italy', prefixes: null, errorPrefix: 'Italian numbers' },
    '+34': { length: 9, name: 'Spain', prefixes: null, errorPrefix: 'Spanish numbers' },
    '+31': { length: 9, name: 'Netherlands', prefixes: null, errorPrefix: 'Dutch numbers' },
    '+32': { length: 9, name: 'Belgium', prefixes: null, errorPrefix: 'Belgian numbers' },
    '+41': { length: 9, name: 'Switzerland', prefixes: null, errorPrefix: 'Swiss numbers' },
    '+46': { length: 9, name: 'Sweden', prefixes: null, errorPrefix: 'Swedish numbers' },
    '+47': { length: 8, name: 'Norway', prefixes: null, errorPrefix: 'Norwegian numbers' },
    '+45': { length: 8, name: 'Denmark', prefixes: null, errorPrefix: 'Danish numbers' },
    '+358': { length: 9, name: 'Finland', prefixes: null, errorPrefix: 'Finnish numbers' },
    '+351': { length: 9, name: 'Portugal', prefixes: null, errorPrefix: 'Portuguese numbers' },
    '+353': { length: 9, name: 'Ireland', prefixes: null, errorPrefix: 'Irish numbers' },
    '+7': { length: 10, name: 'Russia/Kazakhstan', prefixes: null, errorPrefix: 'Russian numbers' },
    '+90': { length: 10, name: 'Turkey', prefixes: null, errorPrefix: 'Turkish numbers' },
    '+52': { length: 10, name: 'Mexico', prefixes: null, errorPrefix: 'Mexican numbers' },
    '+55': { length: 11, name: 'Brazil', prefixes: null, errorPrefix: 'Brazilian numbers' },
    '+54': { length: 10, name: 'Argentina', prefixes: null, errorPrefix: 'Argentine numbers' },
    '+56': { length: 9, name: 'Chile', prefixes: null, errorPrefix: 'Chilean numbers' },
    '+57': { length: 10, name: 'Colombia', prefixes: null, errorPrefix: 'Colombian numbers' },
    '+62': { length: 10, name: 'Indonesia', prefixes: null, errorPrefix: 'Indonesian numbers' },
    '+63': { length: 10, name: 'Philippines', prefixes: null, errorPrefix: 'Philippine numbers' },
    '+84': { length: 10, name: 'Vietnam', prefixes: null, errorPrefix: 'Vietnamese numbers' },
    '+92': { length: 10, name: 'Pakistan', prefixes: null, errorPrefix: 'Pakistani numbers' },
    '+880': { length: 10, name: 'Bangladesh', prefixes: null, errorPrefix: 'Bangladeshi numbers' },
    '+94': { length: 9, name: 'Sri Lanka', prefixes: null, errorPrefix: 'Sri Lankan numbers' },
    '+95': { length: 9, name: 'Myanmar', prefixes: null, errorPrefix: 'Myanmar numbers' },
    '+212': { length: 9, name: 'Morocco', prefixes: null, errorPrefix: 'Moroccan numbers' },
    '+234': { length: 10, name: 'Nigeria', prefixes: null, errorPrefix: 'Nigerian numbers' },
    '+254': { length: 9, name: 'Kenya', prefixes: null, errorPrefix: 'Kenyan numbers' },
    '+233': { length: 9, name: 'Ghana', prefixes: null, errorPrefix: 'Ghanaian numbers' },
    '+256': { length: 9, name: 'Uganda', prefixes: null, errorPrefix: 'Ugandan numbers' },
    '+255': { length: 9, name: 'Tanzania', prefixes: null, errorPrefix: 'Tanzanian numbers' },
    '+972': { length: 9, name: 'Israel', prefixes: null, errorPrefix: 'Israeli numbers' },
    '+961': { length: 8, name: 'Lebanon', prefixes: null, errorPrefix: 'Lebanese numbers' },
    '+962': { length: 9, name: 'Jordan', prefixes: null, errorPrefix: 'Jordanian numbers' },
    '+964': { length: 10, name: 'Iraq', prefixes: null, errorPrefix: 'Iraqi numbers' },
    '+98': { length: 10, name: 'Iran', prefixes: null, errorPrefix: 'Iranian numbers' }
  };

  // Normalize and clean phone number based on country code
  // Removes country code if present, handles double country codes, removes non-digits
  function normalizePhoneNumber(phoneNumber, countryCode) {
    if (!phoneNumber) return '';
    
    // Remove all non-digit characters except + at the start
    let cleaned = phoneNumber.replace(/[^\d+]/g, '');
    
    // Remove leading + if present
    if (cleaned.startsWith('+')) {
      cleaned = cleaned.substring(1);
    }
    
    // Extract country code digits (remove + sign)
    const countryCodeDigits = countryCode.replace(/[^\d]/g, '');
    
    // Remove country code if it appears at the start
    if (cleaned.startsWith(countryCodeDigits)) {
      cleaned = cleaned.substring(countryCodeDigits.length);
    }
    
    // Handle double country code (e.g., 971971...)
    if (cleaned.startsWith(countryCodeDigits)) {
      cleaned = cleaned.substring(countryCodeDigits.length);
    }
    
    // Return only digits
    return cleaned.replace(/\D/g, '');
  }

  // Validate phone number format based on country code
  function validatePhone(phoneNumber, countryCode) {
    if (!phoneNumber || phoneNumber.trim() === '') {
      return { valid: false, error: 'Phone number is required' };
    }
    
    // Get phone format for the country code, default to flexible validation if not found
    const format = PHONE_FORMATS[countryCode] || { length: null, name: 'International', prefixes: null, errorPrefix: 'phone numbers' };
    
    // Normalize the phone number
    const normalized = normalizePhoneNumber(phoneNumber, countryCode);
    
    // If no format is defined, do basic validation (at least 7 digits, max 15)
    if (!format.length) {
      if (normalized.length < 7) {
        return { valid: false, error: 'Phone number is too short' };
      } else if (normalized.length > 15) {
        return { valid: false, error: 'Phone number is too long' };
      }
      return { valid: true, normalized: normalized };
    }
    
    // Check if it matches the expected length
    if (normalized.length !== format.length) {
      if (normalized.length === 0) {
        return { valid: false, error: 'Phone number is required' };
      } else if (normalized.length < format.length) {
        return { valid: false, error: `${format.errorPrefix} must be ${format.length} digits` };
      } else {
        return { valid: false, error: `${format.errorPrefix} must be ${format.length} digits only` };
      }
    }
    
    // Check prefix if specified (e.g., UAE numbers must start with 4, 5, 6, or 7)
    if (format.prefixes && format.prefixes.length > 0) {
      const firstDigit = normalized[0];
      if (!format.prefixes.includes(firstDigit)) {
        return { valid: false, error: `Invalid phone number format. ${format.errorPrefix} start with ${format.prefixes.join(', ')}` };
      }
    }
    
    return { valid: true, normalized: normalized };
  }

  // Auto-fix phone number input (removes country code automatically)
  function autoFixPhoneInput(phoneInput, countryCodeSelect) {
    if (!phoneInput || !countryCodeSelect) return;
    
    const countryCode = countryCodeSelect.value || '+971';
    const currentValue = phoneInput.value;
    
    // Normalize the phone number
    const normalized = normalizePhoneNumber(currentValue, countryCode);
    
    // If the normalized value is different, update the input
    if (normalized !== currentValue.replace(/\D/g, '')) {
      // Set the normalized value (only digits)
      phoneInput.value = normalized;
      
      // Trigger input event to update validation
      phoneInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  // Validate discount code
  function validateDiscountCode(code) {
    if (!code || !code.trim()) {
      return null;
    }
    const normalized = code.toUpperCase().trim();
    return DISCOUNT_CODES[normalized] || null;
  }

  // Calculate discount
  function calculateDiscount(subtotal, discountRate) {
    return subtotal * discountRate;
  }

  // Apply discount to subtotal
  function applyDiscountToSubtotal(subtotal, discountCode) {
    const discount = validateDiscountCode(discountCode);
    if (!discount) {
      return {
        subtotal: subtotal,
        discountAmount: 0,
        total: subtotal,
        discountCode: null
      };
    }
    
    const discountAmount = calculateDiscount(subtotal, discount.rate);
    const total = subtotal - discountAmount;
    
    return {
      subtotal: subtotal,
      discountAmount: parseFloat(discountAmount.toFixed(2)),
      total: parseFloat(total.toFixed(2)),
      discountCode: discountCode.toUpperCase()
    };
  }

  // Validate form
  function validateForm(formData) {
    const errors = {};

    // Email validation
    if (!formData.email || !formData.email.trim()) {
      errors.email = 'Email is required';
    } else if (!validateEmail(formData.email)) {
      errors.email = 'Please enter a valid email address';
    }

    // Shipping address validation
    if (!formData.firstName || !formData.firstName.trim()) {
      errors.firstName = 'First name is required';
    }

    if (!formData.lastName || !formData.lastName.trim()) {
      errors.lastName = 'Last name is required';
    }

    if (!formData.address || !formData.address.trim()) {
      errors.address = 'Address is required';
    }

    if (!formData.city || !formData.city.trim()) {
      errors.city = 'City is required';
    }

    // Get form config for validation
    let formConfig = null;
    if (window.MarketFormConfig) {
      // Try to find config by country name
      for (const [market, config] of Object.entries(window.MarketFormConfig.formConfigs)) {
        if (config.countryName === formData.country) {
          formConfig = config;
          break;
        }
      }
      // Fallback to market-based config
      if (!formConfig && window.MarketConfig) {
        const marketInfo = window.MarketConfig.getCurrentMarket();
        if (marketInfo && marketInfo.config) {
          formConfig = window.MarketFormConfig.getFormConfig(marketInfo.config.market);
        }
      }
    }

    // Default to UAE config if not found
    if (!formConfig) {
      formConfig = window.MarketFormConfig ? window.MarketFormConfig.getFormConfig('UAE') : {
        stateLabel: 'State',
        postalCodeRequired: false
      };
    }

    // Ensure country is set
    if (!formData.country) {
      formData.country = formConfig.countryName || 'United Arab Emirates';
    }

    // Validate state/province/emirate
    if (!formData.state || !formData.state.trim()) {
      errors.state = `${formConfig.stateLabel} is required`;
    }

    // Validate postal code if required
    if (formConfig.postalCodeRequired && (!formData.postalCode || !formData.postalCode.trim())) {
      errors.postalCode = `${formConfig.postalCodeLabel} is required`;
    }

    // Phone validation with normalization
    // formData.phone might already include country code, so we need to extract just the number
    const phoneCountryCode = formData.phoneCountryCode || '+971';
    let phoneNumberToValidate = formData.phone || '';
    
    // If phone already includes country code, remove it for validation
    if (phoneNumberToValidate.startsWith(phoneCountryCode)) {
      phoneNumberToValidate = phoneNumberToValidate.substring(phoneCountryCode.length);
    }
    
    const phoneValidation = validatePhone(phoneNumberToValidate, phoneCountryCode);
    if (!phoneValidation.valid) {
      errors.phone = phoneValidation.error;
    }

    return errors;
  }

  // Show field error
  function showFieldError(fieldName, message) {
    const field = document.getElementById(fieldName);
    if (!field) return;

    field.classList.add('checkout-field--error');
    
    // For phone field, find the parent container (the flex container)
    const parentContainer = fieldName === 'phone' ? field.closest('.checkout-field') : field.parentElement;
    let errorEl = parentContainer.querySelector('.checkout-field__error');
    
    if (!errorEl) {
      errorEl = document.createElement('div');
      errorEl.className = 'checkout-field__error';
      parentContainer.appendChild(errorEl);
    }
    errorEl.textContent = message;
    errorEl.style.display = 'block';
  }

  // Clear field error
  function clearFieldError(fieldName) {
    const field = document.getElementById(fieldName);
    if (!field) return;

    field.classList.remove('checkout-field--error');
    
    // For phone field, find the parent container (the flex container)
    const parentContainer = fieldName === 'phone' ? field.closest('.checkout-field') : field.parentElement;
    const errorEl = parentContainer.querySelector('.checkout-field__error');
    if (errorEl) {
      errorEl.style.display = 'none';
    }
  }

  // Clear all errors
  function clearAllErrors() {
    const errorFields = document.querySelectorAll('.checkout-field--error');
    errorFields.forEach(field => {
      field.classList.remove('checkout-field--error');
    });
    
    const errorMessages = document.querySelectorAll('.checkout-field__error');
    errorMessages.forEach(msg => {
      msg.style.display = 'none';
    });
  }

  // ============================================
  // ORDER SUMMARY
  // ============================================

  // Render order summary
  function renderOrderSummary(cart) {
    const summaryEl = document.getElementById('checkout-order-summary');
    if (!summaryEl || !cart || !cart.items || cart.items.length === 0) {
      return;
    }

    // Get current market currency from MarketConfig
    let marketCurrency = 'AED';
    if (window.MarketConfig && typeof window.MarketConfig.getCurrentMarket === 'function') {
      const marketInfo = window.MarketConfig.getCurrentMarket();
      if (marketInfo && marketInfo.config) {
        marketCurrency = marketInfo.config.currency;
      }
    }
    const subtotal = convertToMarketCurrency(cart.total_price);
    const discountAmount = appliedDiscount ? appliedDiscount.discountAmount : 0;
    const total = subtotal - discountAmount;

    let html = '<div class="checkout-order-summary__items">';
    
    // Get currency symbol from MarketConfig
    let currencySymbol = marketCurrency;
    if (window.MarketConfig && typeof window.MarketConfig.getCurrentMarket === 'function') {
      const marketInfo = window.MarketConfig.getCurrentMarket();
      if (marketInfo && marketInfo.config && marketInfo.config.currencySymbol) {
        currencySymbol = marketInfo.config.currencySymbol;
      }
    }
    
    cart.items.forEach(item => {
      const itemPrice = convertToMarketCurrency(item.line_price);
      html += `
        <div class="checkout-order-summary__item">
          <div class="checkout-order-summary__item-info">
            <div class="checkout-order-summary__item-title">${escapeHtml(item.title || item.product_title || 'Product')}</div>
            <div class="checkout-order-summary__item-variant">${escapeHtml(item.variant_title || '')}</div>
            <div class="checkout-order-summary__item-quantity">Quantity: ${item.quantity}</div>
          </div>
          <div class="checkout-order-summary__item-price">${currencySymbol} ${formatPrice(itemPrice)}</div>
        </div>
      `;
    });
    
    html += '</div>';
    html += '<div class="checkout-order-summary__totals">';
    html += `<div class="checkout-order-summary__row"><span>Subtotal</span><span>${currencySymbol} ${formatPrice(subtotal)}</span></div>`;
    
    // Add shipping line
    html += `<div class="checkout-order-summary__row checkout-order-summary__shipping"><span>Shipping</span><span class="checkout-order-summary__shipping-value">Free</span></div>`;
    
    if (appliedDiscount) {
      html += `<div class="checkout-order-summary__row checkout-order-summary__discount"><span>Discount (${appliedDiscount.discountCode})</span><span>-${currencySymbol} ${formatPrice(discountAmount)}</span></div>`;
    }
    
    html += `<div class="checkout-order-summary__row checkout-order-summary__total"><span>Total</span><span><span class="checkout-order-summary__total-currency">${currencySymbol}</span> ${formatPrice(total)}</span></div>`;
    
    html += '</div>';

    summaryEl.innerHTML = html;
  }

  // Format price
  function formatPrice(amount) {
    return parseFloat(amount).toFixed(2);
  }

  // Escape HTML
  function escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  // ============================================
  // DISCOUNT CODE HANDLING
  // ============================================

  // Handle discount code apply
  function handleDiscountApply() {
    const discountInput = document.getElementById('discount-code');
    const discountError = document.getElementById('discount-error');
    const discountSuccess = document.getElementById('discount-success');
    const discountContent = document.getElementById('discount-content');
    const discountToggle = document.getElementById('discount-toggle');
    
    if (!discountInput || !discountError || !discountContent) {
      return;
    }
    
    const discountCode = discountInput.value.trim();

    // Ensure discount section is expanded when showing errors
    function expandDiscountSection(callback) {
      if (discountContent && discountToggle) {
        const isExpanded = discountToggle.getAttribute('aria-expanded') === 'true';
        if (!isExpanded) {
          discountToggle.setAttribute('aria-expanded', 'true');
          discountContent.style.display = 'block';
          // Force a reflow
          void discountContent.offsetHeight;
          // Set a large max-height to ensure content is visible
          discountContent.style.maxHeight = '500px';
          discountContent.style.opacity = '1';
          
          // Update icon
          const discountToggleIcon = discountToggle.querySelector('.checkout-discount__toggle-icon');
          if (discountToggleIcon) {
            discountToggleIcon.textContent = '▴';
          }
          
          // Wait for transition, then execute callback
          if (callback) {
            setTimeout(callback, 100);
          }
        } else {
          // Even if expanded, ensure it's fully visible
          discountContent.style.display = 'block';
          discountContent.style.maxHeight = '500px';
          discountContent.style.opacity = '1';
          
          if (callback) {
            callback();
          }
        }
      } else if (callback) {
        callback();
      }
    }

    function showError(message) {
      // Hide success message
      if (discountSuccess) {
        discountSuccess.style.display = 'none';
        discountSuccess.textContent = '';
      }
      // Show error message
      discountError.textContent = message;
      discountError.style.display = 'block';
      discountError.style.visibility = 'visible';
      discountError.style.opacity = '1';
    }

    if (!discountCode) {
      expandDiscountSection(() => {
        showError(themeStr('discountRequired', 'Please enter a discount code'));
      });
      return;
    }

    const discount = validateDiscountCode(discountCode);
    
    if (!discount) {
      expandDiscountSection(() => {
        showError(themeStr('discountInvalid', 'Invalid discount code'));
      });
      return;
    }

    // Apply discount - get current market currency
    let currentCurrency = 'AED';
    if (window.MarketConfig && typeof window.MarketConfig.getCurrentMarket === 'function') {
      const marketInfo = window.MarketConfig.getCurrentMarket();
      if (marketInfo && marketInfo.config) {
        currentCurrency = marketInfo.config.currency;
      }
    }
    const subtotal = convertToMarketCurrency(cartData.total_price);
    appliedDiscount = applyDiscountToSubtotal(subtotal, discountCode);
    
    // Update UI
    if (discountError) {
      discountError.style.display = 'none';
    }
    
    // Update order summary
    renderOrderSummary(cartData);
    
    // Show success message
    if (discountSuccess) {
      discountSuccess.textContent = themeStr('discountApplied', 'Discount applied: __VAL__').replace('__VAL__', discount.name);
      discountSuccess.style.display = 'block';
      setTimeout(() => {
        discountSuccess.style.display = 'none';
      }, 3000);
    }
  }

  // ============================================
  // FORM SUBMISSION
  // ============================================

  // Build redirect URL
  function buildRedirectURL(formData, cart) {
    // Detect current market to build correct redirect URL
    let baseURL = '/pages/checkout-redirect';
    if (window.MarketConfig && typeof window.MarketConfig.getCurrentMarket === 'function') {
      const marketInfo = window.MarketConfig.getCurrentMarket();
      if (marketInfo && marketInfo.key !== 'default' && marketInfo.config.path) {
        baseURL = marketInfo.config.path.replace(/\/$/, '') + '/pages/checkout-redirect';
      }
    }
    const params = new URLSearchParams();

    // Calculate subtotal after discount
    let subtotal = convertToMarketCurrency(cart.total_price);
    if (appliedDiscount) {
      subtotal = subtotal - appliedDiscount.discountAmount;
    }

    params.set('subtotal', subtotal.toFixed(2));
    params.set('email', formData.email);
    params.set('phone', formData.phone || '');
    params.set('total_items', cart.items.length.toString());
    
    // Add shipping address data
    params.set('shipping_first_name', formData.firstName);
    params.set('shipping_last_name', formData.lastName);
    params.set('shipping_address1', formData.address);
    params.set('shipping_address2', formData.apartment || '');
    params.set('shipping_city', formData.city);
    params.set('shipping_state', formData.state);
    params.set('shipping_postal_code', formData.postalCode || '');
    params.set('shipping_country', formData.country);

    // Add product data (up to 10 items)
    const maxItems = Math.min(cart.items.length, 10);
    for (let i = 0; i < maxItems; i++) {
      const item = cart.items[i];
      const index = i + 1;
      
      params.set(`product_gid_${index}`, formatProductGID(item.product_id));
      params.set(`variant_id_${index}`, item.variant_id.toString());
      params.set(`quantity_${index}`, item.quantity.toString());
      // Use market currency for price parameter
      const itemPrice = convertToMarketCurrency(item.line_price);
      // Get current currency from MarketConfig
      let currentCurrency = 'AED';
      if (window.MarketConfig && typeof window.MarketConfig.getCurrentMarket === 'function') {
        const marketInfo = window.MarketConfig.getCurrentMarket();
        if (marketInfo && marketInfo.config) {
          currentCurrency = marketInfo.config.currency;
        }
      }
      params.set(`price_${currentCurrency.toLowerCase()}_${index}`, itemPrice.toFixed(2));
      // Keep price_aed for backward compatibility
      params.set(`price_aed_${index}`, itemPrice.toFixed(2));
      
      // Add product name and variant title for Stripe checkout display
      const productName = item.title || item.product_title || '';
      const variantTitle = item.variant_title || '';
      // Combine product name with variant if variant exists
      const displayName = variantTitle ? `${productName} - ${variantTitle}` : productName;
      if (displayName) {
        params.set(`product_name_${index}`, displayName);
      }
      if (window.CartLineItemProperties && typeof window.CartLineItemProperties.jsonForUrlParam === 'function') {
        const propsJson = window.CartLineItemProperties.jsonForUrlParam(item);
        if (propsJson) {
          params.set(`line_item_properties_${index}`, propsJson);
        }
      }
    }

    // Add discount if applied
    if (appliedDiscount) {
      params.set('discount_code', appliedDiscount.discountCode);
      params.set('discount_amount', appliedDiscount.discountAmount.toFixed(2));
    }

    return `${baseURL}?${params.toString()}`;
  }

  // Handle form submission
  async function handleFormSubmit(e) {
    e.preventDefault();

    // Clear previous errors
    clearAllErrors();

    // Get form data
    const phoneCountryCodeSelect = document.getElementById('phone-country-code');
    const phoneInput = document.getElementById('phone');
    const phoneCountryCode = phoneCountryCodeSelect?.value || '+971';
    
    // Auto-fix phone number (remove country code if present)
    if (phoneInput && phoneCountryCodeSelect) {
      autoFixPhoneInput(phoneInput, phoneCountryCodeSelect);
    }
    
    const phoneNumber = phoneInput?.value.trim() || '';
    const phoneValidation = validatePhone(phoneNumber, phoneCountryCode);
    
    // If phone is invalid, show error and return
    if (!phoneValidation.valid) {
      showFieldError('phone', phoneValidation.error);
      const phoneField = document.getElementById('phone');
      if (phoneField) {
        phoneField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        phoneField.focus();
      }
      return;
    }
    
    // Use normalized phone number
    const normalizedPhone = phoneValidation.normalized;
    const fullPhone = phoneCountryCode + normalizedPhone;
    
    const formData = {
      email: document.getElementById('email').value.trim(),
      phone: fullPhone,
      phoneCountryCode: phoneCountryCode,
      firstName: document.getElementById('first-name').value.trim(),
      lastName: document.getElementById('last-name').value.trim(),
      address: document.getElementById('address').value.trim(),
      apartment: document.getElementById('apartment').value.trim(),
      city: document.getElementById('city').value.trim(),
      state: document.getElementById('state').value.trim(),
      postalCode: document.getElementById('postal-code')?.value.trim() || '',
      country: document.getElementById('country').value || 'United Arab Emirates'
    };

    // Validate form
    const errors = validateForm(formData);
    if (Object.keys(errors).length > 0) {
      // Show errors
      Object.keys(errors).forEach(fieldName => {
        showFieldError(fieldName, errors[fieldName]);
      });
      
      // Scroll to first error
      const firstErrorField = document.querySelector('.checkout-field--error');
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstErrorField.focus();
      }
      return;
    }

    // Show loading state on both buttons
    const submitButton = document.getElementById('checkout-submit');
    const submitButtonMobile = document.getElementById('checkout-submit-mobile');
    if (submitButton) {
      submitButton.disabled = true;
      submitButton.textContent = themeStr('processing', 'Processing...');
    }
    if (submitButtonMobile) {
      submitButtonMobile.disabled = true;
      submitButtonMobile.textContent = themeStr('processing', 'Processing...');
    }

    try {
      // Detect locale/market using MarketConfig
      let localeInfo = { currency: 'INR', market: 'INR' };
      
      if (window.MarketConfig && typeof window.MarketConfig.getCurrentMarket === 'function') {
        const marketInfo = window.MarketConfig.getCurrentMarket();
        if (marketInfo && marketInfo.config) {
          localeInfo = {
            currency: marketInfo.config.currency,
            market: marketInfo.config.market
          };
        }
      } else {
        // Fallback to old detection method
      const path = window.location.pathname || '';
      const hostname = window.location.hostname || '';
      const href = window.location.href || '';
      const isArAe = path.includes('/ar-ae/') || hostname.includes('ar-ae') || href.includes('/ar-ae/');
      const isEnAe = (window.shopifyLocale && window.shopifyLocale.isEnAe) || path.includes('/en-ae/') || hostname.includes('en-ae') || href.includes('/en-ae/');
      const isArSa = path.includes('/ar-sa/') || hostname.includes('ar-sa') || href.includes('/ar-sa/');
      const isEnSa = path.includes('/en-sa/') || hostname.includes('en-sa') || href.includes('/en-sa/');
      if (isArAe || isEnAe) {
        localeInfo = { currency: 'AED', market: 'UAE' };
      } else if (isArSa || isEnSa) {
        localeInfo = { currency: 'SAR', market: 'Saudi Arabia' };
      } else {
        localeInfo = { currency: 'INR', market: 'INR' };
      }
      }

      // Build webhook payload
      const webhookPayload = buildWebhookPayload(cartData, formData, localeInfo);
      
      // Send webhook BEFORE redirect (with timeout) - use market-specific URL
      try {
        console.log('[Custom Checkout] Sending form submit webhook...');
        const webhookURL = getWebhookURL('form-submit');
        const webhookPromise = sendWebhook(webhookPayload, webhookURL);
        const webhookTimeout = new Promise((_, reject) => 
          setTimeout(() => reject(new Error('Webhook timeout')), 3000)
        );
        
        await Promise.race([webhookPromise, webhookTimeout]).catch((error) => {
          console.error('[Custom Checkout] Form submit webhook error:', error);
        });
      } catch (error) {
        console.error('[Custom Checkout] Form submit webhook exception:', error);
        // Continue with redirect even if webhook fails
      }

      // Build redirect URL
      const redirectURL = buildRedirectURL(formData, cartData);

      // Redirect to payment page
      window.location.href = redirectURL;

    } catch (error) {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = themeStr('payNow', 'Pay Now');
      }
      if (submitButtonMobile) {
        submitButtonMobile.disabled = false;
        submitButtonMobile.textContent = themeStr('payNow', 'Pay Now');
      }
      
      alert(themeStr('checkoutGenericError', 'An error occurred. Please try again.'));
    }
  }

  // ============================================
  // FORM INITIALIZATION
  // ============================================

  // Populate phone country code dropdown
  function populatePhoneCountryCodes() {
    const phoneCountryCodeSelect = document.getElementById('phone-country-code');
    if (!phoneCountryCodeSelect) return;

    // All phone country codes (from PHONE_FORMATS)
    const phoneCodes = Object.keys(PHONE_FORMATS).sort();
    
    // Clear existing options except the first one (if it exists)
    phoneCountryCodeSelect.innerHTML = '';
    
    phoneCodes.forEach(code => {
      const format = PHONE_FORMATS[code];
      const option = document.createElement('option');
      option.value = code;
      option.textContent = `${code} (${format.name})`;
      phoneCountryCodeSelect.appendChild(option);
    });
  }

  // Initialize form fields based on market
  function initializeFormFields() {
    // Wait for MarketConfig and MarketFormConfig to load
    if (!window.MarketConfig || !window.MarketFormConfig) {
      setTimeout(initializeFormFields, 100);
      return;
    }

    const marketInfo = window.MarketConfig.getCurrentMarket();
    if (!marketInfo || !marketInfo.config) {
      return;
    }

    const market = marketInfo.config.market;
    const formConfig = window.MarketFormConfig.getFormConfig(market);

    // Populate phone country code dropdown
    populatePhoneCountryCodes();

    // Populate country dropdown
    const countrySelect = document.getElementById('country');
    if (countrySelect) {
      const countries = window.MarketFormConfig.getAvailableCountries();
      countrySelect.innerHTML = '';
      countries.forEach(country => {
        const option = document.createElement('option');
        option.value = country.name;                 // submitted value: English
        option.textContent = placeLabel(country.name);  // shopper-visible label
        if (country.name === formConfig.countryName) {
          option.selected = true;
        }
        countrySelect.appendChild(option);
      });

      // Update form when country changes
      countrySelect.addEventListener('change', function() {
        updateFormForCountry(this.value);
      });
    }

    // Set default phone country code
    const phoneCountryCodeSelect = document.getElementById('phone-country-code');
    if (phoneCountryCodeSelect && formConfig.phoneCountryCode) {
      phoneCountryCodeSelect.value = formConfig.phoneCountryCode;
    }

    // Initialize form for default country
    updateFormForCountry(formConfig.countryName);
  }

  // Update form fields based on selected country
  function updateFormForCountry(countryName) {
    if (!window.MarketFormConfig) return;

    // Find form config for this country
    let formConfig = null;
    for (const [market, config] of Object.entries(window.MarketFormConfig.formConfigs)) {
      if (config.countryName === countryName) {
        formConfig = config;
        break;
      }
    }

    // Fallback to UAE if not found
    if (!formConfig) {
      formConfig = window.MarketFormConfig.getFormConfig('UAE');
    }

    // Update state field
    const stateFieldContainer = document.getElementById('state-field-container');
    if (stateFieldContainer) {
      const existingStateField = document.getElementById('state');
      const existingErrorDiv = stateFieldContainer.querySelector('.checkout-field__error');
      
      if (formConfig.stateFieldType === 'select' && formConfig.stateOptions.length > 0) {
        // Convert to select if it's text
        if (!existingStateField || existingStateField.tagName !== 'SELECT') {
          const newSelect = document.createElement('select');
          newSelect.id = 'state';
          newSelect.name = 'state';
          newSelect.className = 'checkout-field__select';
          newSelect.required = true;
          
          // Preserve error div
          if (existingStateField) {
            existingStateField.replaceWith(newSelect);
          } else {
            stateFieldContainer.appendChild(newSelect);
          }
          
          if (!existingErrorDiv) {
            const errorDiv = document.createElement('div');
            errorDiv.className = 'checkout-field__error';
            stateFieldContainer.appendChild(errorDiv);
          }
        }

        // Populate options
        const stateField = document.getElementById('state');
        if (stateField) {
          stateField.innerHTML = '<option value=""></option>';
          stateField.options[0].textContent = themeStr('selectField', 'Select __VAL__')
            .replace('__VAL__', fieldLabel(formConfig.stateLabel));
          formConfig.stateOptions.forEach(option => {
            const opt = document.createElement('option');
            opt.value = option.value;
            opt.textContent = placeLabel(option.label);
            stateField.appendChild(opt);
          });
        }
      } else {
        // Convert to text input if it's select
        if (!existingStateField || existingStateField.tagName !== 'INPUT') {
          const newInput = document.createElement('input');
          newInput.type = 'text';
          newInput.id = 'state';
          newInput.name = 'state';
          newInput.className = 'checkout-field__input';
          newInput.required = true;
          newInput.autocomplete = 'address-level1';
          newInput.placeholder = fieldLabel(formConfig.stateLabel) + ' *';
          
          // Preserve error div
          if (existingStateField) {
            existingStateField.replaceWith(newInput);
          } else {
            stateFieldContainer.appendChild(newInput);
          }
          
          if (!existingErrorDiv) {
            const errorDiv = document.createElement('div');
            errorDiv.className = 'checkout-field__error';
            stateFieldContainer.appendChild(errorDiv);
          }
        } else {
          // Update placeholder for existing text input
          existingStateField.placeholder = fieldLabel(formConfig.stateLabel) + ' *';
        }
      }
    }

    // Update postal code field
    const postalCodeField = document.getElementById('postal-code-field');
    const postalCodeInput = document.getElementById('postal-code');
    if (postalCodeField && postalCodeInput) {
      if (formConfig.postalCodeRequired) {
        postalCodeField.style.display = 'block';
        postalCodeInput.required = true;
        postalCodeInput.placeholder = fieldLabel(formConfig.postalCodeLabel) + ' *';
      } else {
        postalCodeField.style.display = 'none';
        postalCodeInput.required = false;
        postalCodeInput.value = '';
      }
    }

    // Update phone country code when country changes
    const phoneCountryCodeSelect = document.getElementById('phone-country-code');
    if (phoneCountryCodeSelect && formConfig.phoneCountryCode) {
      phoneCountryCodeSelect.value = formConfig.phoneCountryCode;
      // Trigger change event to re-validate phone
      phoneCountryCodeSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // ============================================
  // INITIALIZATION
  // ============================================

  // Initialize checkout
  async function initCustomCheckout() {
    // Wait for MarketConfig and MarketFormConfig to load
    if (!window.MarketConfig || !window.MarketFormConfig) {
      setTimeout(initCustomCheckout, 100);
      return;
    }

    // Initialize form fields based on market
    initializeFormFields();

    // Load cart data first
    cartData = await getCartData();
    
    if (!cartData || !cartData.items || cartData.items.length === 0) {
      // Redirect to cart if empty - use market-specific path if available
      let cartURL = '/cart';
      if (window.MarketConfig && typeof window.MarketConfig.getCurrentMarket === 'function') {
        const marketInfo = window.MarketConfig.getCurrentMarket();
        if (marketInfo && marketInfo.key !== 'default' && marketInfo.config.path) {
          cartURL = marketInfo.config.path.replace(/\/$/, '') + '/cart';
        }
      }
      window.location.href = cartURL;
      return;
    }

    // Send initiate checkout webhook (built from cart data and cookies)
    // This happens when the page loads, so it's reliable
    await sendInitiateCheckoutWebhook(cartData);

    // Render order summary
    renderOrderSummary(cartData);

    // Set up discount code toggle
    const discountToggle = document.getElementById('discount-toggle');
    const discountContent = document.getElementById('discount-content');
    const discountToggleIcon = discountToggle ? discountToggle.querySelector('.checkout-discount__toggle-icon') : null;
    
    if (discountToggle && discountContent) {
      discountToggle.addEventListener('click', function() {
        const isExpanded = discountToggle.getAttribute('aria-expanded') === 'true';
        discountToggle.setAttribute('aria-expanded', !isExpanded);
        
        // Update icon character
        if (discountToggleIcon) {
          discountToggleIcon.textContent = isExpanded ? '▾' : '▴';
        }
        
        if (!isExpanded) {
          discountContent.style.display = 'block';
          // Trigger reflow to ensure animation plays
          discountContent.offsetHeight; 
          discountContent.style.maxHeight = discountContent.scrollHeight + 'px';
          discountContent.style.opacity = '1';
        } else {
          discountContent.style.maxHeight = '0';
          discountContent.style.opacity = '0';
          discountContent.addEventListener('transitionend', function handler() {
            discountContent.style.display = 'none';
            discountContent.removeEventListener('transitionend', handler);
          }, { once: true });
        }
      });
    }

    // Set up discount code handler
    const discountApplyBtn = document.getElementById('discount-apply');
    if (discountApplyBtn) {
      discountApplyBtn.addEventListener('click', handleDiscountApply);
    }

    const discountInput = document.getElementById('discount-code');
    if (discountInput) {
      discountInput.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          handleDiscountApply();
        }
      });
      
      // Clear error message when user starts typing
      discountInput.addEventListener('input', () => {
        const discountError = document.getElementById('discount-error');
        const discountSuccess = document.getElementById('discount-success');
        if (discountError) {
          discountError.style.display = 'none';
        }
        if (discountSuccess) {
          discountSuccess.style.display = 'none';
        }
      });
    }

    // Set up form submission
    const checkoutForm = document.getElementById('checkout-form');
    if (checkoutForm) {
      checkoutForm.addEventListener('submit', handleFormSubmit);
    }

    // Real-time validation
    const emailField = document.getElementById('email');
    if (emailField) {
      emailField.addEventListener('blur', () => {
        const email = emailField.value.trim();
        if (email && !validateEmail(email)) {
          showFieldError('email', 'Please enter a valid email address');
        } else {
          clearFieldError('email');
        }
      });
    }

    // Real-time phone validation and auto-fix
    const phoneInput = document.getElementById('phone');
    const phoneCountryCodeSelect = document.getElementById('phone-country-code');
    if (phoneInput && phoneCountryCodeSelect) {
      // Auto-fix phone number on input (removes country code automatically)
      phoneInput.addEventListener('input', () => {
        // Auto-fix the phone number
        autoFixPhoneInput(phoneInput, phoneCountryCodeSelect);
        
        // Clear error when user starts typing
        clearFieldError('phone');
      });
      
      // Validate phone number on blur
      phoneInput.addEventListener('blur', () => {
        const phoneNumber = phoneInput.value.trim();
        const countryCode = phoneCountryCodeSelect.value || '+971';
        const phoneValidation = validatePhone(phoneNumber, countryCode);
        
        if (!phoneValidation.valid) {
          showFieldError('phone', phoneValidation.error);
        } else {
          clearFieldError('phone');
          // Update the input with normalized value
          if (phoneValidation.normalized !== phoneNumber) {
            phoneInput.value = phoneValidation.normalized;
          }
        }
      });
      
      // Also auto-fix and re-validate when country code changes
      phoneCountryCodeSelect.addEventListener('change', () => {
        autoFixPhoneInput(phoneInput, phoneCountryCodeSelect);
        
        // Re-validate with new country code
        const phoneNumber = phoneInput.value.trim();
        if (phoneNumber) {
          const countryCode = phoneCountryCodeSelect.value || '+971';
          const phoneValidation = validatePhone(phoneNumber, countryCode);
          
          if (!phoneValidation.valid) {
            showFieldError('phone', phoneValidation.error);
          } else {
            clearFieldError('phone');
            // Update the input with normalized value
            if (phoneValidation.normalized !== phoneNumber) {
              phoneInput.value = phoneValidation.normalized;
            }
          }
        }
      });
    }

    // Clear errors on input
    const formFields = document.querySelectorAll('#checkout-form input, #checkout-form select');
    formFields.forEach(field => {
      // Skip phone field as it has its own handler
      if (field.id !== 'phone') {
        field.addEventListener('input', () => {
          clearFieldError(field.id);
        });
      }
    });

    // Form fields are now initialized dynamically by initializeFormFields()
    // No need for hardcoded country-specific logic here
  }

  // Run when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomCheckout);
  } else {
    initCustomCheckout();
  }

})();
